/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import CheckBox from '../Common/checkbox';

const AddColumn = ({ fields, handleChange }) => (
  <ul className="dropdown-menu">
    {fields.map(field => (
      <li key={field.name} className="dropdown-options">
        <CheckBox
          label={field.name}
          value={field.name}
          checked={field.visible}
          handleCheckboxChange={handleChange}
        />
      </li>
    ))}
  </ul>
);

AddColumn.propTypes = {
  fields: PropTypes.array,
  handleChange: PropTypes.func
};

export default AddColumn;
